import { endPoints, requestType } from "../constants/variables";
import Api from "./index";

export const getActivity = () => {
  return Api(endPoints.getActivity, requestType.GET);
};

export const getEmployeeAnalytics = (workerId) => {
  return Api(`${endPoints.getEmployeeAnalytics}/${workerId}`, requestType.GET);
};
